import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfiguration } from "@app/lib/services/app-config.service";
import { BaseHttpService } from "@app/lib/services/base-http.service";
import { TAny } from "@app/lib/models/common.type";
import { FeeAssessmentModel, FeeAssessmentResponse, FeeComponent, FeeComponentType, PaymentType, } from "../models/fee-assessment.model";
import { IResponse } from "@app/lib/models/response.model";
import { PrintRecieptRequest } from "../models/document-reception.model";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class FeeAssessmentService extends BaseHttpService {

  private baseUrl:string;
    constructor(http: HttpClient, appConfig: AppConfiguration) {
        super(http, appConfig);
        this.baseUrl = this.appConfig.hostUrl;
    }


    getfeeAssessment(queryParams: TAny) {
        return this.get<IResponse<FeeAssessmentModel>>('fee-assessment/search.htm', { params: { ...queryParams } });
    }
    save(reqBody:TAny){
        return this.post<IResponse<TAny>,TAny>('fee-assessment/update.htm',reqBody);
      }
    getPrint(reqBody: TAny): Observable<Blob> {
        const params = new HttpParams()
        .set('docId', reqBody.docId || '')
        .set('id', reqBody.id?.toString() || '')
        .set('governmentParty', reqBody.governmentParty?.toString() || '')
        .set('feeAmount', reqBody.feeAmount?.toString() || '')
        .set('pages', reqBody.pages?.toString() || '')
        .set('remarks',reqBody.remarks || '');
        
            const url = `${this.baseUrl}fee-assessment/view-report.htm`;
            return this.http.get(url, { params, responseType: 'blob' });
          }
    getRecordfeeComponent(queryParams: TAny) {
            return this.get<IResponse<FeeComponent[]>>('fee-components/search.htm', { params: { ...queryParams } });
        }

    getfeeComponentType(): Observable<IResponse<FeeComponentType[]>> {
              return this.get<IResponse<FeeComponentType[]>>('fee-components/types.htm');
  
      }
    getPaymentTypes(): Observable<IResponse<PaymentType[]>>{
        return this.get<IResponse<PaymentType[]>>('fee-components/payment-types.htm');

}
feePaymentPrint(reqBody: FeeComponent|TAny): Observable<Blob> {
  const params = {'feeComponentId':reqBody.feeComponentId?.toString() || '',
    'caseNumber':reqBody.caseNumber || '',
    'docId':reqBody.docId || '',
    'feeCompTypesId':reqBody.feeCompTypesId?.toString() || '',
    'feeCompTypesName':reqBody.feeCompTypesName || '',
    'feePaid':reqBody.feePaid?.toString() || '',
    'paymentTypesId':reqBody.paymentTypesId?.toString() || '',
    'remarks':reqBody.remarks || '',
    'courtType':'',
    'docTypeId':reqBody.docTypeId?.toString() || '',
    'govtPartyFlag':reqBody.govtPartyFlag?.toString() || ''};

  const url = `${this.baseUrl}fee-components/view-report.htm`;
  return this.http.get(url, { params, responseType: 'blob' });
}
feePaymentSave(reqBody:TAny){
  return this.post<IResponse<TAny>,TAny>('fee-components/upsert.htm',reqBody);
}


}